import { IOrderLink } from './interfaces/IOrderLink';
import { eClientIntent } from '../enums/eClientIntent';

export const selectFirstOrderLinkClientIntent = (
  orderLinks: IOrderLink[],
  transactionId: string | null
): eClientIntent | undefined => {
  if (orderLinks.length && transactionId) {
    const firstOrderLink = orderLinks[0];
    const item = firstOrderLink.items.find((item) => item.orderId === transactionId);
    return item ? item.clientIntent : undefined;
  }
  return undefined;
};
